import { useEffect, useState } from "react";
import firebase from "firebase/app";
import "firebase/firestore";
import { Notification } from "../../types/Notification";

// Replace with your own path or import the DB_PATH constant if available
const DB_PATH = {
  NOTIFICATION: "Notification",
};

type NotificationResponse = {
  loading: boolean;
  error: boolean;
  notifications: Notification[];
};

export default ({
  isRead,
  communityId,
}: {
  isRead?: boolean; // Optional filter for read/unread notifications
  communityId?: string; // Optional filter for notifications specific to a community
}): NotificationResponse => {
  const [notificationResponse, setNotificationResponse] =
    useState<NotificationResponse>({
      loading: true,
      error: false,
      notifications: [],
    });

  useEffect(() => {
    console.log("coMMUNITYID", communityId);
    // Reference the notifications collection from Firestore
    const notificationsCollection = firebase
      .firestore()
      .collection(DB_PATH.NOTIFICATION);

    // Start with the base collection reference
    let queryRef: firebase.firestore.Query = notificationsCollection;

    // Apply a filter by communityId if provided
    if (communityId) {
      queryRef = queryRef.where("communityId", "==", communityId);
    }

    // Listen for realtime updates using onSnapshot
    const unsubscribe = queryRef.onSnapshot(
      (snapshot) => {
        const notificationsSnap: Notification[] = snapshot.docs.map((doc) => ({
          id: doc.id, // include the document ID
          ...doc.data(), // spread the document data
        })) as Notification[];

        console.log("NotificationsSnap", notificationsSnap);
        // Use a functional update to avoid stale state issues
        setNotificationResponse((prev) => ({
          ...prev,
          notifications: notificationsSnap,
          loading: false,
        }));
      },
      (error) => {
        console.error("Error fetching notifications:", error);
        setNotificationResponse((prev) => ({
          ...prev,
          error: true,
          loading: false,
        }));
      }
    );

    // Clean up the listener on unmount
    return () => unsubscribe();
  }, [isRead, communityId]);

  return notificationResponse;
};
